import { TestActionTypes } from "../constants/TestActionTypes";

const TestState = {
    status: "",
    _id: "",
    c_id: "",
    exam_id: "",
    s_id: "",
    examiner_id: "",
    screen_left_count: 0,
    batch: "",
    startDateTime: "",
    endDateTime: "",
    questions: []

}


export const TestReducer = (state = TestState, { type, payload }) => {
    switch (type) {
        case TestActionTypes.ADD_TEST_DETAILS:
            var updatedState = {
                status: payload.status,
                _id: payload._id,
                c_id: payload.c_id,
                exam_id: payload.exam_id,
                s_id: payload.s_id,
                examiner_id: payload.examiner_id,
                screen_left_count: payload.screen_left_count,
                batch: "",
                startDateTime: payload.startDateTime,
                endDateTime: payload.endDateTime,
                questions: []
            }
            return updatedState;

        case TestActionTypes.UPDATE_TEST_DETAILS:
            const updatedState_UPDATE_TEST_DETAILS = { ...state };
            updatedState_UPDATE_TEST_DETAILS.batch = payload.batch;
            updatedState_UPDATE_TEST_DETAILS.questions = payload.questions;
            return updatedState_UPDATE_TEST_DETAILS

        case TestActionTypes.INC_SCREEN_COUNT:
            const updatedState_INC_SCREEN_COUNT = {...state};
            updatedState_INC_SCREEN_COUNT.screen_left_count = state.screen_left_count + 1;
            return updatedState_INC_SCREEN_COUNT;


        default:
            return state;
    }
}